import { LoginResponse, TwoFactorAuthLoginVerifyRequestDTO, TwoFactorMethod } from "./interfaces";
import axiosInstance from '../../../../../../utils/axios';
import { JWTPayload } from "./models";
import { handleAuthError } from "./errors";
import { decodeJWT } from "../../utils/decodedJWT";

export const verifyTwoFactorLogin = async (
  payload: TwoFactorAuthLoginVerifyRequestDTO,
  remember: boolean,
): Promise<{ tokens: LoginResponse; user: JWTPayload }> => {
  try {
    const response = await axiosInstance.post<LoginResponse>(
      '/two-factor-auth/verify',
      payload,
    );

    const tokens = response.data;

    if (remember) {
      localStorage.setItem('accessToken', tokens.accessToken);
      localStorage.setItem('refreshToken', tokens.refreshToken);
    } else {
      sessionStorage.setItem('accessToken', tokens.accessToken);
      sessionStorage.setItem('refreshToken', tokens.refreshToken);
    }

    const decoded = decodeJWT(tokens.accessToken);

    if (!decoded) {
      throw new Error('Failed to decode the JWT.');
    }

    return { tokens, user: decoded };
  } catch (error: any) {
    handleAuthError?.(error);
    throw error;
  }
};

export const sendTwoFactorCode = async (email: string) => {
  await axiosInstance.post('/two-factor-auth/send-code', {
    email,
    method: TwoFactorMethod.EMAIL,
  });
};
